import React from 'react';
import { Button, Card, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DocumentType } from '../../../generated/graphql';

type DocumentTypeProper = { __typename?: 'DocumentType' | undefined } & Pick<
    DocumentType,
    'isCategory' | 'name' | 'id'
>;

export interface DocumentTypeListProps {
    array: DocumentTypeProper[];
    isCategory: boolean;
    onClick(documentType: DocumentTypeProper): void;
    navigateToCreateDocumentType?(isCategory: boolean): void;
}

export const DocumentTypeList: React.FC<DocumentTypeListProps> = ({
    array,
    isCategory,
    onClick,
    navigateToCreateDocumentType,
}) => {
    const [t] = useTranslation();
    return (
        <Card style={{ marginBottom: 15 }}>
            <Card.Header
                style={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Card.Title>
                    {isCategory ? t('admin.pages.document_type.categories') : t('admin.pages.document_type.documents')}
                </Card.Title>

                {navigateToCreateDocumentType && (
                    <Button onClick={() => navigateToCreateDocumentType(isCategory)}>
                        {isCategory
                            ? t('admin.pages.document_type.create_new_category')
                            : t('admin.pages.document_type.create_new_document')}
                    </Button>
                )}
            </Card.Header>

            <ListGroup variant="flush">
                {!array.length && (
                    <div
                        style={{
                            width: '100%',
                            height: 100,
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                        }}
                    >
                        {isCategory
                            ? t('admin.pages.document_type.empty_category')
                            : t('admin.pages.document_type.empty_documents')}
                    </div>
                )}
                {!!array.length &&
                    array.map((item) => {
                        return (
                            <ListGroup.Item style={{ cursor: 'pointer' }} key={item.id} onClick={() => onClick(item)}>
                                {item.name}
                            </ListGroup.Item>
                        );
                    })}
            </ListGroup>
        </Card>
    );
};
